import axios from "axios";
import { BasicActivity } from "types/activity.type";
import {
  ActivityEmailTemplate,
  EmailTemplate,
  EmailTemplateTranslation,
  NewActivityEmailTemplate,
  NewEmailTemplate,
} from "types/emailTemplate.type";
import { getAuthorizedConfig } from "../../helpers/helpers";

export async function getClientSetting(): Promise<any> {
  const clientId = localStorage.getItem("clientId");
  let config = getAuthorizedConfig("GET");
  config["url"] =
    `${process.env.REACT_APP_API_URL}/client-settings/${clientId}`;
  const response = await axios.request(config);
  return response.data;
}

export async function getActivitiesWithEmailTemplates(): Promise<{
  data: {
    activities: BasicActivity[];
    activityEmailTemplates: ActivityEmailTemplate[];
  };
}> {
  let config = getAuthorizedConfig("GET");
  config["url"] = `${process.env.REACT_APP_API_URL}/email-templates/activities`;
  const response = await axios.request(config);
  return response.data;
}

export async function getEmailTemplates(): Promise<{ data: EmailTemplate[] }> {
  let config = getAuthorizedConfig("GET");
  config["url"] = `${process.env.REACT_APP_API_URL}/email-templates`;
  const response = await axios.request(config);
  return response.data;
}

export async function getEmailTemplateById(
  id: string,
): Promise<EmailTemplate & { translations: EmailTemplateTranslation[] }> {
  let config = getAuthorizedConfig("GET");
  config["url"] = `${process.env.REACT_APP_API_URL}/email-templates/${id}`;
  const response = await axios.request(config);
  return response.data;
}

export async function getAlertEmailTemplate(): Promise<any> {
  let config = getAuthorizedConfig("GET");
  config["url"] =
    `${process.env.REACT_APP_API_URL}/email-templates/toggle-alert`;
  const response = await axios.request(config);
  return response.data;
}

export async function updateActivitiesEmailTemplate(data: {
  assignments: NewActivityEmailTemplate[];
}): Promise<any> {
  let config = getAuthorizedConfig("POST");
  config["url"] = `${process.env.REACT_APP_API_URL}/email-templates/activities`;
  config["data"] = data;
  const response = await axios.request(config);
  return response.data;
}

export async function createEmailTemplate(
  emailTemplate: NewEmailTemplate,
): Promise<{ data: EmailTemplate }> {
  let config = getAuthorizedConfig("POST");
  config["url"] = `${process.env.REACT_APP_API_URL}/email-templates`;
  config["data"] = emailTemplate;
  const response = await axios.request(config);
  return response.data;
}

export async function deleteEmailTemplate(
  id: number,
): Promise<{ data: { id: number } }> {
  let config = getAuthorizedConfig("DELETE");
  config["url"] =
    `${process.env.REACT_APP_API_URL}/email-templates/${id.toString()}`;
  const response = await axios.request(config);
  return response.data;
}

export async function updateEmailTemplate(
  emailTemplate: NewEmailTemplate & { id: number },
): Promise<{ data: EmailTemplate }> {
  let config = getAuthorizedConfig("PUT");
  config["url"] =
    `${process.env.REACT_APP_API_URL}/email-templates/${emailTemplate.id}`;
  config["data"] = {
    ...emailTemplate,
    attachments: emailTemplate.attachments?.map((attachment) =>
      attachment.base64File ? attachment : attachment.url,
    ),
  };
  const response = await axios.request(config);
  return response.data;
}
